module.exports = __webpack_public_path__ + "static/img/9.c66ae13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/9.png
// module id = Wo4W
// module chunks = 0